import { NodeViewRendererProps, NodeViewWrapper } from '@tiptap/react'
import { Image } from 'antd'
import React from 'react'

export const EditImage: React.FC<NodeViewRendererProps> = ({ ...props }: NodeViewRendererProps) => {
  let container
  if (document.querySelector('.fullscreen-container')) {
    container = '.fullscreen-container'
  }
  return (
    <NodeViewWrapper>
      <Image src={props.node.attrs.src} preview={{ src: props.node.attrs.src, getContainer: container }}></Image>
    </NodeViewWrapper>
  )
}
